export default (sourceArray, groupByPropName) =>
  //groups the sourceArray by provided property
  sourceArray?.reduce((acc, cur) => {
    let newAcc = [...acc];
    let foundItem = newAcc.find(
      (x) => x[groupByPropName] === cur[groupByPropName]
    );
    if (!foundItem) {
      foundItem = { [groupByPropName]: cur[groupByPropName], items: [] };
      newAcc = [...newAcc, foundItem];
    }
    const item = { ...cur };
    delete item[groupByPropName];
    foundItem.items = [...foundItem.items, item];
    return newAcc; //returns an array of objects for all the sections { sectionName, items }
  }, []);
